import _isEmpty from "lodash/isEmpty";

const state = {
    cardInfo: {}
}

const mutations = {
    SET_CARD_INFO(state, cardInfo) {
        state.cardInfo = cardInfo;
    },
    CLEAN_UP_DATA(state) {
        state.cardInfo = {};
    }
}

const actions = {
    getData({ dispatch }) {
        // get the user wallet info
        dispatch("updateCardInfo");
    },
    setCardInfo({ commit }, coins) {
        commit("SET_CARD_INFO", coins);
    },
    cleanUpData({ commit }) {
        commit("CLEAN_UP_DATA");
    },
    getInfo() {
        return axios.get("/v2/user");
    },
    getCardInfo() {
        return axios.get("/v2/payment/stripe/creditcard")
    },
    updateCardInfo({ dispatch }) {
        return dispatch("getCardInfo").then(({ data: cardInfo }) => {
            dispatch("setCardInfo", {
                lastFour: cardInfo.last4,
                expMonth: cardInfo.exp_month,
                expYear: cardInfo.exp_year,
                brand: cardInfo.brand,
                country: cardInfo.country
            });
        }).catch(() => {
            console.log("Something Went Wrong");
        });
    }
}

const getters = {
    userHasCard(state) {
        return !_isEmpty(state.cardInfo);
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
